<template>
  <div>
    <NavigationBar />
    <div class="container mt-3">
      <div class="d-flex align-items-center mb-2">
        <button
          type="button"
          class="btn btn-secondary btn-sm me-2"
          @click="goBack"
        >
          Vissza
        </button>
        <div class="flex-grow-1">
          <h4 class="mb-0">Útvonal térkép – ID: {{ utvonalId }}</h4>

          <small v-if="tavolsg || pontvonalHossz" class="text-muted">
              <span v-if="viszonylat"> {{ viszonylat }} · </span>
            <span v-if="tavolsg">Távolság: {{ tavolsg }} km</span>
            <span v-if="tavolsg && pontvonalHossz"> · </span>
            <span v-if="pontvonalHossz">Pontvonal hossz: {{ pontvonalHossz }} km</span>
          </small>
        </div>
      </div>

      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>

      <div id="utvonal-map" style="height: 780px; width: 100%;"></div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import axiosInstance from '@/axiosInstance';
import NavigationBar from '@/views/NavigationBar.vue';

// Fix, damit die Standard-Marker-Icons in Vite/Webpack korrekt geladen werden
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href,
  iconUrl:       new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href,
  shadowUrl:     new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).href
});





export default {
  name: 'UtvonalMap',
  components: { NavigationBar },
  props: ['id'],
  data() {
    return {
      utvonalId: this.id,
      map: null,

      // neu
      encodedPolyline: '',
      latLngs: [],

      // optional: Zusatzinfos aus API
      tavolsg: null,
      pontvonalHossz: null,

      viszonylat: null,
      
      loading: false,
      error: null
    };
  },
  async mounted() {
    await this.loadRoute();
    this.initMap();
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },

  methods: {

createFinishIcon() {
  const finishSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <rect x="6" y="3" width="2" height="26" fill="#333"/>
    <rect x="5" y="28" width="4" height="2" fill="#333"/>
    <path d="M8 5 C14 3, 18 7, 24 5 L24 16 C18 18, 14 14, 8 16 Z" fill="#fff" stroke="#111" stroke-width="1"/>
    <g transform="translate(9,6)">
      <rect x="0"  y="0" width="3" height="3" fill="#000"/>
      <rect x="3"  y="0" width="3" height="3" fill="#fff"/>
      <rect x="6"  y="0" width="3" height="3" fill="#000"/>
      <rect x="9"  y="0" width="3" height="3" fill="#fff"/>
      <rect x="12" y="0" width="3" height="3" fill="#000"/>

      <rect x="0"  y="3" width="3" height="3" fill="#fff"/>
      <rect x="3"  y="3" width="3" height="3" fill="#000"/>
      <rect x="6"  y="3" width="3" height="3" fill="#fff"/>
      <rect x="9"  y="3" width="3" height="3" fill="#000"/>
      <rect x="12" y="3" width="3" height="3" fill="#fff"/>

      <rect x="0"  y="6" width="3" height="3" fill="#000"/>
      <rect x="3"  y="6" width="3" height="3" fill="#fff"/>
      <rect x="6"  y="6" width="3" height="3" fill="#000"/>
      <rect x="9"  y="6" width="3" height="3" fill="#fff"/>
      <rect x="12" y="6" width="3" height="3" fill="#000"/>
    </g>
  </svg>
  `;

  return L.icon({
    iconUrl: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(finishSvg.trim()),
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32]
  });
},

createStartIcon() {
  const pinSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="44" viewBox="0 0 32 44">
    <path d="M16 43 C16 43 29 28 29 18 C29 9.7 23.2 3 16 3 C8.8 3 3 9.7 3 18 C3 28 16 43 16 43 Z"
          fill="#19a34a" stroke="#0b5d2b" stroke-width="2"/>
    <circle cx="16" cy="18" r="6" fill="#ffffff" opacity="0.95"/>
  </svg>
  `;
  return L.icon({
    iconUrl: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(pinSvg.trim()),
    iconSize: [32, 44],
    iconAnchor: [16, 44],
    popupAnchor: [0, -40]
  });
},


    goBack() {
      this.$router.back();
    },

 async loadRoute() {
    this.loading = true;
    this.error = null;

    try {
      const resp = await axiosInstance.post(
        'https://bogir.hu/V2/api/utvonal/get_utvonal.php',
        { utvonal_az: this.utvonalId }
      );

      const row = resp?.data?.data?.[0];
      if (!row?.polyline) {
        this.error = 'Keine Route (polyline) vom Server erhalten.';
        return;
      }

      this.encodedPolyline = row.polyline;

      this.tavolsg = row.tavolsg ?? null;
      this.pontvonalHossz = row.pontvonal_hossz ?? null;
      this.viszonylat=row.viszonylat;

      // FIX: precision = 5
      const coords = this.decodePolyline(this.encodedPolyline, 5);
      this.latLngs = coords.map(([lat, lng]) => L.latLng(lat, lng));

      if (!this.latLngs.length) {
        this.error = 'Polyline konnte nicht decodiert werden (keine Koordinaten).';
      }
    } catch (e) {
      console.error('Fehler beim Laden der Route:', e);
      this.error = 'Fehler beim Laden der Route. Details siehe Console.';
    } finally {
      this.loading = false;
    }
  },

    initMap() {
      if (!this.latLngs.length) return;

      if (this.map) this.map.remove();

      this.map = L.map('utvonal-map', {
        preferCanvas: true // Performance bei vielen Punkten
      });

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.map);

      const routeLine = L.polyline(this.latLngs, {
        weight: 4
      }).addTo(this.map);

      // Start / Cél
      const startLatLng = this.latLngs[0];
      const endLatLng = this.latLngs[this.latLngs.length - 1];

      L.marker(startLatLng, { icon: this.createStartIcon() })
    .addTo(this.map)
    .bindPopup('Start');
    
      L.marker(endLatLng, { icon: this.createFinishIcon() })
        .addTo(this.map)
        .bindPopup('Cél');

      this.map.fitBounds(routeLine.getBounds(), { padding: [20, 20] });
    },

    // --- Polyline decode (Google Encoded Polyline Algorithm) ---
    // Rückgabe: Array von [lat, lng]
decodePolyline(encoded, precision = 5) {
    if (!encoded || typeof encoded !== 'string') return [];

    let index = 0;
    let lat = 0;
    let lng = 0;
    const coordinates = [];
    const factor = Math.pow(10, precision);

    while (index < encoded.length) {
      let result = 0;
      let shift = 0;
      let b;

      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const deltaLat = (result & 1) ? ~(result >> 1) : (result >> 1);
      lat += deltaLat;

      result = 0;
      shift = 0;

      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const deltaLng = (result & 1) ? ~(result >> 1) : (result >> 1);
      lng += deltaLng;

      coordinates.push([lat / factor, lng / factor]);
    }

    return coordinates;
  },



  }
};
</script>

<style scoped>
#utvonal-map {
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
